import { Component, OnInit } from '@angular/core';
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { PasswordSuccessfulService } from './password-successful.service';
@Component({
  selector: 'app-password-successful',
  templateUrl: './password-successful.component.html',
  styleUrls: ['./password-successful.component.scss']
})
export class PasswordSuccessfulComponent implements OnInit {
    public modalOpen: boolean;

  constructor(
    public activeModal: NgbActiveModal,
    private _passwordSuccessfulService: PasswordSuccessfulService,

  ) { }

  ngOnInit() {
    this._passwordSuccessfulService.modal.subscribe(isOpen => {
        console.log("i received to open modal ?", isOpen);
        this.modalOpen = isOpen as boolean;
    });
  }
  closeModal() {
    this._passwordSuccessfulService.close();
    this.activeModal.dismiss();
}
}



// WEBPACK FOOTER //
// ./src/app/password-successful/password-successful.component.ts